/**
 * T284 — Quartal-status banner (FR-043a).
 *
 * Shows a non-intrusive banner when the current quarter for the active
 * tenant is marked `closed`. Admin + Stbr can reopen from the banner
 * (href to /admin); GF can still save expenses with `confirmNachträglich`.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { quartalKeys } from '../../services/api/keys';
import { useActiveTenantId } from '../../hooks/useTenantContext';

interface QuartalRow {
  id: string;
  tenantId: string;
  year: number;
  quarter: number;
  status: 'open' | 'closed';
}

function currentQuartal(): { year: number; quarter: number } {
  const now = new Date();
  return { year: now.getFullYear(), quarter: Math.floor(now.getMonth() / 3) + 1 };
}

export function QuartalStatusBanner() {
  const { year, quarter } = currentQuartal();
  const tenantId = useActiveTenantId();
  const { data } = useQuery({
    queryKey: quartalKeys.year(tenantId, year),
    queryFn: () => api.get<{ items: QuartalRow[] }>(`/quartal-status?year=${year}`),
    enabled: tenantId !== null,
  });
  const match = data?.items.find((q) => q.year === year && q.quarter === quarter);
  if (!match || match.status === 'open') return null;

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 text-amber-100 px-4 py-2 rounded text-sm">
      ⚠️ Quartal {year}-Q{quarter} ist abgeschlossen. Nachträgliche Belege werden
      als <code className="px-1 py-0.5 rounded bg-amber-500/20">nachträglich</code> markiert
      und benötigen Bestätigung beim Speichern.
    </div>
  );
}
